const get = (key)=>{
    try {
        const data = sessionStorage.getItem(key);
        return data !== null ? JSON.parse(data).value : null;
    } catch (error) {
        console.error('Error while accessing session storage', error);
        return null;
    }
};
const set = (key, value)=>{
    try {
        sessionStorage.setItem(key, JSON.stringify({
            value
        }));
    } catch (error) {
        console.error('Error while accessing session storage', error);
    }
};
const remove = (key)=>{
    try {
        sessionStorage.removeItem(key);
    } catch (error) {
        console.error('Error while accessing session storage', error);
    }
};

export { get, remove, set };
